import React, { Component } from 'react'
import ReactTooltip from "react-tooltip";
import Sounds from "./Sounds"
import Seed from "./Seed";
import Help from "./Help";
import { RiRouteFill } from "react-icons/ri";
import { IoIosMusicalNotes } from "react-icons/io";
import { SlEnergy } from "react-icons/sl";


class TopBar extends Component {
    render() {
        const {handleShowPopUp}= this.props;
        return (
            <>
                <ReactTooltip />
                <div style={{display:"flex",gap:"8px"}} className="btn-group btn-group-toggle">
                    <Sounds />
                    <Seed  />
                    <Help content={this.props.help} image={this.props.image} />
                </div>
            </>
        );
    }
}

export default TopBar;
